import React from 'react';
import { useAtomValue } from 'jotai';
import type { PageConfig } from 'c-config';
import { PermissionName } from 'c-sdk';
import { atom_useLegacyDashboard } from 'c-wrapper/Atoms/legacyViewAtoms';
import { useUserPermissions } from 'c-auth-module/Hooks';
import currentSetup from './MainDashboardPage';
import mainSetup from './MainDashboardPage.main';
import { showsDashboardV2 } from './dashboardVersion';

const CurrentComponent = currentSetup.component;
const MainComponent = mainSetup.component;

// Renders the customisable dashboard (2.0) or the pre-customisation (main branch) one: see
// showsDashboardV2 for who gets which.
const DashboardHomeToggle = (): JSX.Element => {
    const adminUsesLegacy = useAtomValue(atom_useLegacyDashboard);
    const { isAdmin, hasAll } = useUserPermissions();
    const v2 = showsDashboardV2({
        isAdmin,
        adminUsesLegacy,
        hasV2Permission: hasAll([PermissionName.ReportingDashboard_v2]),
    });
    const Component = v2 ? CurrentComponent : MainComponent;
    return <Component />;
};

const setup: PageConfig = { ...currentSetup, component: DashboardHomeToggle };

export default setup;
